import {createModel} from '@@/package/utils/ModelUtil';
import Model from '@@/package/mapper/Model';

export enum ErrorType {
    SERVER_ERROR = "SERVER_ERROR",
    CODE_ERROR = "CODE_ERROR"
}

export class CodeRunModel extends Model {
    constructor(
        public output: string = "",
        public error: string = "",
        public errorType: ErrorType | null = null,
        public byteImageData: string[] = [],
        public testCaseType: string = "SKIP",
        public streamingType: string = "TAIL",
        public message: string = "",
        public end: boolean = false,
        public isPass: boolean = false,
        public errorGuide: string = "",
        public outputDescription: string = "",
        public validSet: string = "",

        public score: number | undefined = undefined
    ) {
        super();
    }

    public static create(model: Partial<CodeRunModel>): CodeRunModel {
        return createModel<CodeRunModel>(CodeRunModel, {
            ...model
        });
    }
}
